import { axios } from '@util'

class FCPVariance {
  async getFCPVariances({ UMR, page, page_size }) {
    return await axios({
      url: '/fcp_variance/',
      params: {
        ...(UMR ? { UMR } : null),
        page: page || 1,
        page_size: page_size || 10
      }
    })
  }

  async createFCPVariance({
    UMR,
    variance_type,
    variance_type_other_reason,
    submit_variance_comment,
    submit_variance_user,
    admin_variance_status,
    admin_variance_date,
    admin_variance_comment,
    admin_variance_user,
    variance_report_period,
    Claim_Reference
  }) {
    return await axios({
      url: `/fcp_variance/`,
      method: 'POST',
      data: {
        ...(UMR ? { UMR } : null),
        ...(variance_type ? { variance_type } : null),
        ...(variance_type_other_reason ? { variance_type_other_reason } : null),
        ...(submit_variance_comment ? { submit_variance_comment } : null),
        ...(submit_variance_user ? { submit_variance_user } : null),
        ...(undefined !== typeof admin_variance_status
          ? { admin_variance_status }
          : null),
        ...(admin_variance_date ? { admin_variance_date } : null),
        ...(admin_variance_comment ? { admin_variance_comment } : null),
        ...(admin_variance_user ? { admin_variance_user } : null),
        ...(variance_report_period ? { variance_report_period } : null),
        ...(Claim_Reference ? { Claim_Reference } : null)
      }
    })
  }

  async createOrUpdateFCPVariance({
    id,
    UMR,
    variance_type,
    variance_type_other_reason,
    submit_variance_comment,
    submit_variance_user,
    admin_variance_status,
    admin_variance_date,
    admin_variance_comment,
    admin_variance_user,
    variance_report_period,
    Claim_Reference,
    account_name
  }) {
    // Forward every field the caller actually passed, including null/''/0 - RecProductionReport.vue
    // relies on sending an explicit blank/null value to CLEAR an already-saved field (LIQ-2444),
    // which the previous `value ? { value } : null` truthy guards silently dropped before the
    // request ever left the browser (a falsy value spread null into the body, omitting the key
    // entirely - indistinguishable, from the backend's perspective, from never having sent it at
    // all, so the backend correctly left the existing value untouched instead of clearing it).
    // Only `undefined` (the caller truly didn't pass this key) is omitted now, matching what a
    // plain object spread of the caller's own body would already do for every other field.
    return await axios({
      url: id ? `/fcp_variance/${id}/` : `/fcp_variance/`,
      method: id ? 'PUT' : 'POST',
      data: {
        ...(undefined !== UMR ? { UMR } : null),
        ...(undefined !== variance_type ? { variance_type } : null),
        ...(undefined !== variance_type_other_reason ? { variance_type_other_reason } : null),
        ...(undefined !== submit_variance_comment ? { submit_variance_comment } : null),
        ...(undefined !== submit_variance_user ? { submit_variance_user } : null),
        ...(undefined !== admin_variance_status ? { admin_variance_status } : null),
        ...(undefined !== admin_variance_date ? { admin_variance_date } : null),
        ...(undefined !== admin_variance_comment ? { admin_variance_comment } : null),
        ...(undefined !== admin_variance_user ? { admin_variance_user } : null),
        ...(undefined !== variance_report_period ? { variance_report_period } : null),
        ...(undefined !== Claim_Reference ? { Claim_Reference } : null),
        ...(undefined !== account_name ? { account_name } : null)
      }
    })
  }

  async readFCPVariance(id) {
    return await axios({
      url: `/fcp_variance/${id}/`
    })
  }

  async updateFCPVariance(
    id,
    {
      UMR,
      variance_type,
      variance_type_other_reason,
      submit_variance_comment,
      submit_variance_user,
      admin_variance_status,
      admin_variance_date,
      admin_variance_comment,
      admin_variance_user,
      variance_report_period,
      Claim_Reference
    }
  ) {
    return await axios({
      url: `/fcp_variance/${id}/`,
      method: 'PUT',
      data: {
        ...(UMR ? { UMR } : null),
        ...(variance_type ? { variance_type } : null),
        ...(variance_type_other_reason ? { variance_type_other_reason } : null),
        ...(submit_variance_comment ? { submit_variance_comment } : null),
        ...(submit_variance_user ? { submit_variance_user } : null),
        ...(undefined !== typeof admin_variance_status
          ? { admin_variance_status }
          : null),
        ...(admin_variance_date ? { admin_variance_date } : null),
        ...(admin_variance_comment ? { admin_variance_comment } : null),
        ...(admin_variance_user ? { admin_variance_user } : null),
        ...(variance_report_period ? { variance_report_period } : null),
        ...(Claim_Reference ? { Claim_Reference } : null)
      }
    })
  }

  async deleteFCPVariance(id) {
    return await axios({
      url: `/fcp_variance/${id}/`,
      method: 'DELETE'
    })
  }
}

export default new FCPVariance()
